<template>
  <div>

    <el-row>
      <el-button type="primary" @click="deleteEmpAndAttach()" style="margin-right:20px;">移除人员</el-button>
      <el-button type="primary" @click="selecPerson()" style="margin-right:20px;">选取其他人员</el-button>
      <el-button v-if="!isSelect" type="primary" @click="allSelection()"  style="margin-right:20px;">多人共用文件上传</el-button>
      <sbsp-file-upload v-else :file-ids.sync="multipleSelection" :allSelection="true" limit="5" @refushAttachment="_getListpage">
        <el-button type="primary" @click="allSelection()" style="margin-right:20px;">多人共用文件上传</el-button>
      </sbsp-file-upload>
      <el-button type="primary" @click="goBack()" style="margin-right:20px;">返回</el-button>
    </el-row>

    <el-table
      :data="tableData"
      ref="multipleTable"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getListpage"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="name"
        label="姓名"
        width="150"
        align="center"
      >
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>

      <el-table-column
        label="证件号码"
        width="200"
        align="center"
      >
        <template slot-scope="scope">{{ scope.row.idCard }}</template>
      </el-table-column>

      <el-table-column
        label="人员标识"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <span v-for="(item,i) in scope.row.empMark" :key="i">
          {{item | dictFilter(dicts)}}
          <span v-if="i!=scope.row.empMark.length-1">,</span>
        </span>
        </template>

      </el-table-column>

      <el-table-column label="文件" width="500px" align="center">
        <template slot-scope="scope">
          <div v-for="(fileId,i) in scope.row.fileIds" :key="fileId.uid" class="fileName">
            <el-tooltip v-if="fileId.owner"placement="bottom" effect="light"  >
              <span slot="content">附件公用人:{{fileId.owner}}</span>
              <img src="@/assets/img/formUpload/icon-duoren.png" alt="" srcset="">
            </el-tooltip>
            <span :class="{oneOwner:!fileId.owner}">{{fileId.fileName}}</span>  <span class="downLoad" @click="downLoad(fileId.fileId)">下载</span>
            <span class="del" @click="deleteAttachMent(fileId.uid,fileId.owner)">删除</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span>
            <sbsp-file-upload :file-ids.sync="scope.row.fileIds"
                              :empId="scope.row.empId"
                              :batchId="scope.row.batchId"
                              :specialType="true"
                              limit="5"
                              @refushAttachment="_getListpage">
              <div class="upload" align="center">
                  上传
              </div>
              </sbsp-file-upload>
           </span>
        </template>
      </el-table-column>
    </el-table>
<!--    <el-pagination-->
<!--         @size-change="handleSizeChange"-->
<!--         @current-change="handleCurrentChange"-->
<!--         :current-page="currentPage"-->
<!--         :page-sizes="[10, 20, 30, 50, 100]"-->
<!--         :page-size="pageSize"-->
<!--         layout="total, sizes, prev, pager, next"-->
<!--         :total="tableData.length"-->
<!--         background-->
<!--    >-->
<!--    </el-pagination>-->

    <div style="margin-top:30px;">
      <sbspFileUploadDetails></sbspFileUploadDetails>
    </div>

    <el-dialog
      ref="selectPersonDialog"
      width="70%"
      id="selectPerson"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="选取其他人员"
      :visible.sync="dialogheaderVisible"
    >
      <div v-if="dialogheaderVisible">
        <selectPerson
                      ref="selectPerson"
                      :perDatas.sync="perDatas"
                      @refushAttchment="_getListpage"
                      @performDialog="performDialog"
                      :cusId="cusId"
        >
        </selectPerson>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import sbspFileUpload from "@/views/wage/attachmentManage/sbsp-form-file-upload";
  import sbspFileUploadDetails from "@/views/wage/attachmentManage/sbsp-form-file-details";
  import selectPerson from "@/views/wage/attachmentManage/selectPerson.vue";
  import { downLoadFile,getFileInfo} from "@/api/user/user.js";
  import { queryEmpListPage,deleteAttachMent,deleteEmpAndAttachInfo} from "@/api/wage/attachmentManage.js";
  import { downloadFile } from '@/util/util';
  import {dictListFilter} from '@/filters/index.js';
  import {queryOrgTreeSelect,getCusData} from "@/api/wage/payGroup";
  import {mapGetters} from "vuex";
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  export default {
    components: {
        sbspFileUpload,
        sbspFileUploadDetails,
        selectPerson
    },
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    created(){
      this._getCusData();
      this._getListpage();
      console.log("this.total------",this.total);

    },
    data() {
      return {
        total:0,
        pageSize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        dialogheaderVisible:false,
        itemList:['aa','bb','cc'],
        tableData: [],
        multipleSelection: [],
        perDatas:[],
        listQuery:{
          limit: 10,
          page: 1,
          total: 0,
          batchId:this.$route.query.batchId,
        },
        deleteList:{
          selectedList:[],
          batchId : this.$route.query.batchId
        },
        isSelect:false,
        cusId:''
      }
    },

    methods: {
      //每页多少条
      handleSizeChange(val) {
          this.pageSize = val;
      },
      // 当前页
      handleCurrentChange(val) {
          this.currentPage = val;
      },
        //查询客户id
      _getCusData(){
          getCusData().then((res) => {
              console.log('获取当前客户Id：', res.data.data.cusId);
              this.cusId= res.data.data.cusId;
              // this._queryOrgTreeSelect(this.cusId);
              // console.log('当前CodeItem分页对象为：'+JSON.stringify(this.list))
          });
      },
        //查询列表数据
      _getListpage(e){
        this.perDatas = [];
        queryEmpListPage(this.listQuery).then(res => {
            console.log("dayin-------res==",res);
          this.listQuery.total = res.data.total;
          this.tableData = res.data;
          if(res.data){
              let personList = res.data;
              personList.forEach(row=>{
                  console.log("roww==",row);
                  let obj = {
                      id:row.empId
                  }
                  this.perDatas.push(obj);
              })
          }
        })
      },
        performDialog(){
          console.log("hello----今天六月就1111");
          this.dialogheaderVisible = false;
        },
      allSelection(rows) {
         console.log("点击多人共用文件上传==rows=",rows)
          if(this.multipleSelection.length < 1){
              this.$message.warning("请至少选择一条数据！")
          }else{
              console.log("已经选择2条数据");
          }
      },
      goBack(){
        this.$router.go(-1);//返回上一层
      },
        //删除雇员
      deleteEmpAndAttach(){
          if(this.multipleSelection.length < 1){
              this.$message.warning("请至少选择一条数据！")
          }else{
              this.$confirm('是否确认删除?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then((action) => {
                  if (action === 'confirm') {
                      this.deleteList.selectedList = this.multipleSelection;
                      console.log("this.deleteList==",this.deleteList);
                      deleteEmpAndAttachInfo(this.deleteList).then(res=>{
                          console.log("删除6-10=res",res);
                          if(res.data.data){
                            this.$message.success("删除成功！");
                            this._getListpage();
                          }else {
                            this.$message.error("删除失败！")
                          }
                      })
                  }
              }).catch(() => {
                  this.$message.info("已取消删除");
              });


          }
      },
      selecPerson(){
        this.dialogheaderVisible = true;
        // setTimeout(() => {
        // console.log("this.$refs.selectPerson=========",this.$refs.selectPerson);
        // this.$refs.selectPerson.$refs.table._getListpage();
        // }, 2000);
        this.$forceUpdate();
      },
      downLoad(id){
        downLoadFile(id).then(res => {
          downloadFile(res)
        })
      },
      deleteAttachMent(id,owner){
        this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then((action) => {
            if (action === 'confirm') {
                let obj = {
                    id:id,
                    owner:owner
                }
              deleteAttachMent(obj).then(res => {
                  this._getListpage();
              })
            }
        }).catch(() => {
            this.$message.info("已取消删除");
        });

      },
      handleSelectionChange(val) {
          console.log("handleSelectionChange=======val==",val)
        this.multipleSelection = val;
        if(this.multipleSelection && this.multipleSelection.length > 0){
            this.isSelect = true
        }else{
            this.isSelect = false
        }
      }
    }
  }
</script>
<style scoped>
  .downLoad,.del{
    font-size:12px;
    margin-left: 20px;
    font-weight:500;
    color:rgba(64,158,255,1);
    line-height:17px;
    cursor: pointer;
  }
  .fileName{
    padding-bottom: 10px;
    line-height: 17px;
  }
  .fileName img,.fileName span{
    vertical-align: middle;
  }
  .fileName span{
    height:17px;
    line-height:17px;
  }
  .fileName span.oneOwner{
    padding-left:42px;
  }
  .fileName img{
    margin-right: 20px;
  }
  .fileName:nth-last-of-type(1){
    padding-bottom: 0;
  }
  .el-row{
    text-align: right;
    margin-bottom: 10px;
  }
  .upload{
    font-size:12px;
    margin-right: 50px;
    font-weight:500;
    color:rgba(64,158,255,1);
    line-height:17px;
  }
</style>
